// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.admin-common-space1-EUpCb {
	margin-bottom: 6px !important;
}

.admin-common-space2-zWH_W {
	margin-bottom: 12px !important;
}

.admin-common-space3-VPBJ_ {
	margin-bottom: 18px !important;
}

.admin-common-space4-wjti5 {
	margin-bottom: 24px !important;
}

.admin-common-space5-EP1Pj {
	margin-bottom: 30px !important;
}

.admin-common-space6-TR6XW {
	margin-bottom: 36px !important;
}

.admin-common-space7-aDYEi {
	margin-bottom: 42px !important;
}

.admin-common-space8-tH87P {
	margin-bottom: 48px !important;
}

.admin-common-spaceTop1-yt9D5 {
	margin-top: 6px !important;
}

.admin-common-spaceTop2-XVhPG {
	margin-top: 12px !important;
}

.admin-common-spaceTop3-bOf9o {
	margin-top: 18px !important;
}

.admin-common-spaceTop4-G2Y_3 {
	margin-top: 24px !important;
}

.admin-common-spaceTop5-uxjKO {
	margin-top: 30px !important;
}

.admin-common-spaceTop6-WXTbd {
	margin-top: 36px !important;
}

.admin-common-spaceTop7-IOcZY {
	margin-top: 42px !important;
}

.admin-common-spaceTop8-lpaUv {
	margin-top: 48px !important;
}

.admin-common-noMargin-xiyaX {
	margin: 0px !important;
}

.admin-common-padding1-fkpFl {
	padding-bottom: 6px !important;
}

.admin-common-padding2-utxnM {
	padding-bottom: 12px !important;
}

.admin-common-padding3-jl9Oh {
	padding-bottom: 18px !important;
}

.admin-common-padding4-coj31 {
	padding-bottom: 24px !important;
}

.admin-common-padding5-QS7wE {
	padding-bottom: 30px !important;
}

.admin-common-padding6-TnaWJ {
	padding-bottom: 36px !important;
}

.admin-common-padding7-XUGQV {
	padding-bottom: 42px !important;
}

.admin-common-paddingTop1-n0hRz {
	padding-top: 6px !important;
}

.admin-common-paddingTop2-DW4ND {
	padding-top: 12px !important;
}

.admin-common-paddingTop3-LmzY3 {
	padding-top: 18px !important;
}

.admin-common-paddingTop4-D_wRe {
	padding-top: 24px !important;
}

.admin-common-paddingTop5-H_v9a {
	padding-top: 30px !important;
}

.admin-common-paddingTop6-zgg9B {
	padding-top: 36px !important;
}

.admin-common-paddingTop7-yssBl {
	padding-top: 42px !important;
}

.admin-common-noPadding-Yj5SJ {
	padding: 0px !important;
}

.admin-common-spaceMarginBottom0-ESBiv {
	margin-bottom: 0;
}

.admin-common-textBold-FXcH4 {
	font-weight: 500 !important;
}

.admin-common-textBolder-nzptV {
	font-weight: 700 !important;
}

.admin-common-textNormal-XHEB8 {
	font-weight: normal !important;
}

/*New Design Text Colors */

.admin-common-textDarkBlue-JnHam {
	color: rgb(20, 39, 94) !important;
}

.admin-common-textLightBlue-rKfzR {
	color: rgb(57, 87, 106) !important;
}

.admin-common-textLightSandleGreen-SzcnA {
	color: rgb(76, 86, 41) !important;
}

.admin-common-textLightBrown-c50qS {
	color: rgb(115, 79, 33) !important;
}

.admin-common-textMediumMaroon-Nkitm {
	color: rgb(87, 37, 51) !important;
}

.admin-common-textBrown-VzOa0 {
	color: rgb(160, 47, 24) !important;
}

.admin-common-textMaroon-ahu0K {
	color: rgb(155, 49, 67) !important;
}

.admin-common-textDarkBrown-UsXO5 {
	color: rgb(83, 18, 16) !important;
}

.admin-common-textMediumBrown-hHkvR {
	color: rgb(142, 28, 10) !important;
}

.admin-common-textSkyBlue-SQvqO {
	color: rgb(37, 117, 141) !important;
}

.admin-common-textGray-Lcc8k {
	color: rgb(77, 65, 51) !important;
}

.admin-common-errorMessage-j5Ygy {
  margin-top: 5px;
  margin-bottom: 5px;
  display: block;
  color: var(--alert-color);
  font-size: 14px;
  font-weight: normal;
  /* margin-left: 5px; */
}

/** Admin - Common - Start **/

.admin-common-userText-rsGMR {
	padding-top: 3px;
	color: var(--common-text-color);
	margin: 0px;
	font-size: 14px;
}

.admin-common-panelHeader-chzWo {
	border-radius: 4px;
	padding: 20px 25px;
	border: 1px solid var(--primary-border);
}

.admin-common-exportSection-vVJQP {
	background: var(--common-gray-bg-color);
	padding: 24px 15px;
	display: grid;
	grid-template-columns: 28% 15% 55%;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	grid-gap: 11px;
	border: 1px solid var(--primary-border);
	border-bottom: 0;
	border-top-left-radius: 20px;
	border-top-right-radius: 20px;
}

.admin-common-exportSectionGridSub-lBU2P {
	grid-template-columns: 50% 49% !important;
}

.admin-common-exportText-Qyk3F {
	color: var(--common-text-color) !important;
	text-decoration: none !important;
	display: inline-block;
	float: right;
}

.admin-common-exportLinkImg-G1EAi {
	background: var(--primary-white-bg);
	padding: 10px;
	margin-left: 12px;
	border-radius: 4px;
}

.admin-common-exportImg-ZxYbH {
	width: 100%;
	max-width: 16px;
	vertical-align: middle;
}

.admin-common-linkBtn-IGCPQ {
	line-height: 24px;
	display: inline-block;
	vertical-align: middle;
	margin-right: 15px;
	text-align: center;
}

.admin-common-table-aD00b {
	display: table;
}

.admin-common-tableRow-Qhsi0 {
	display: table-row;
}

.admin-common-tableCell-_9nUx {
	display: table-cell;
	float: none;
}

.admin-common-formGroup-zT4cQ {
	margin-bottom: 6px;
}

.admin-common-marginTop0-K13Ia {
	margin-top: 0;
}

.admin-common-marginBottom20-_G4yi {
	margin-bottom: 20px;
}

/******************* Admin Banner Image Section Start ****************/

.admin-common-bannerImageBg-kGZc6 {
	width: 100%;
	height: 100%;
	min-height: 179px;
	background-size: contain;
	background-repeat: no-repeat;
	background-position: 50% 50%;
	position: relative;
	border-radius: 0px;
}

.admin-common-bannerDelete-PiySL {
	position: absolute;
	top: 5px;
	right: 20px;
}

/*******************Admin Modal Start **********************/

a,
a:hover {
	cursor: pointer;
}

.admin-common-exportLink-WGQAF {
	padding-top: 10px;
	padding-right: 10px;
}

.admin-common-seachContent-ZYA_w {
	padding-left: 0px;
	margin-bottom: 5px;
}

.admin-common-marginBottom9-XKvSQ {
	margin-bottom: 9px;
}

.admin-common-spaceTop52-mcs6I {
	margin-top: 52px;
}

.admin-common-profileViewInner-sS3aA {
	padding: 10px;
	border-top: 1px solid var(--primary-border);
	word-break: break-all;
}

.admin-common-profileViewMain-TBRXl {
	border: 1px solid var(--primary-border);
	border-radius: 0px;
	border-top: 0;
}

.admin-common-profileViewlabel-z7FPz {
	display: inline-block;
	width: 38%;
	vertical-align: middle;
}

.admin-common-profileViewMainContent-OW6Eo {
	display: inline-block;
	width: 62%;
	vertical-align: middle;
}

.admin-common-reviewsFormStar-H9ymj {
	font-size: 32px;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	gap: 2px;
	-ms-flex-wrap: wrap;
	    flex-wrap: wrap;
}

.admin-common-reviewsFormStar-H9ymj svg {
	cursor: pointer;
}

.admin-common-addLanguageText-SJQ74 {
	font-size: 16px;
}

/***************** Export Section Start *********************/

@media screen and (max-width: 991px) {
	.admin-common-exportSection-vVJQP {
		grid-template-columns: 100%;
	}

	.admin-common-spaceTop52-mcs6I {
		margin-top: 18px;
	}

	.admin-common-exportText-Qyk3F {
		float: none;
		margin-top: 12px;
	}

	.admin-common-exportSectionGridSub-lBU2P {
		grid-template-columns: 100% !important;
	}
}

/***************** Export Section End *********************/

/*******************Admin Modal Start **********************/

/*******************Admin Modal End **********************/

/*********************** Profile View Section  Start***********************/

@media screen and (max-width: 767px) {
	.admin-common-profileViewlabel-z7FPz {
		width: 100%;
		margin-bottom: 6px;
		text-align: center;
	}

	.admin-common-profileViewMainContent-OW6Eo {
		width: 100%;
		text-align: center;
	}

	.admin-common-panelHeader-chzWo {
		padding: 15px 15px;
	}

}

/*********************** Profile View Section  Start***********************/`, "",{"version":3,"sources":["webpack://./src/components/helpers.css","webpack://./src/components/utils.css","webpack://./src/components/siteadmin/admin-common.css"],"names":[],"mappings":"AAAA;CACC,6BAA6B;AAC9B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA,0BAA0B;;AAE1B;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,mCAAmC;AACpC;;AAEA;CACC,iCAAiC;AAClC;;AC5LA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,mBAAmB;EACnB,sBAAsB;AACxB;;ACLA,6BAA6B;;AAC7B;CACC,gBAAgB;CAChB,+BAA+B;CAC/B,WAAW;CACX,eAAe;AAChB;;AAEA;CACC,kBAAkB;CAClB,kBAAkB;CAClB,uCAAuC;AACxC;;AAEA;CACC,uCAAuC;CACvC,kBAAkB;CAClB,aAAa;CACb,kCAAkC;CAClC,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,cAAc;CACd,uCAAuC;CACvC,gBAAgB;CAChB,4BAA4B;CAC5B,6BAA6B;AAC9B;;AAEA;CACC,yCAAyC;AAC1C;;AAEA;CACC,0CAA0C;CAC1C,gCAAgC;CAChC,qBAAqB;CACrB,YAAY;AACb;;AAEA;CACC,mCAAmC;CACnC,aAAa;CACb,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,WAAW;CACX,eAAe;CACf,sBAAsB;AACvB;;AAEA;CACC,iBAAiB;CACjB,qBAAqB;CACrB,sBAAsB;CACtB,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,mBAAmB;CACnB,WAAW;AACZ;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,mBAAmB;AACpB;;AAGA,sEAAsE;;AACtE;CACC,WAAW;CACX,YAAY;CACZ,iBAAiB;CACjB,wBAAwB;CACxB,4BAA4B;CAC5B,4BAA4B;CAC5B,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,WAAW;AACZ;;AAEA,4DAA4D;;AAC5D;;CAEC,eAAe;AAChB;;AAEA;CACC,iBAAiB;CACjB,mBAAmB;AACpB;;AAEA;CACC,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,2CAA2C;CAC3C,qBAAqB;AACtB;;AAEA;CACC,uCAAuC;CACvC,kBAAkB;CAClB,aAAa;AACd;;AAEA;CACC,qBAAqB;CACrB,UAAU;CACV,sBAAsB;AACvB;;AAEA;CACC,qBAAqB;CACrB,UAAU;CACV,sBAAsB;AACvB;;AAEA;CACC,eAAe;CACf,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,QAAQ;CACR,mBAAe;KAAf,eAAe;AAChB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,eAAe;AAChB;;AAEA,6DAA6D;;AAC7D;CACC;EACC,2BAA2B;CAC5B;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,WAAW;EACX,gBAAgB;CACjB;;CAEA;EACC,sCAAsC;CACvC;AACD;;AAEA,2DAA2D;;AAC3D,4DAA4D;;AAE5D,0DAA0D;;AAE1D,2EAA2E;;AAG3E;CACC;EACC,WAAW;EACX,kBAAkB;EAClB,kBAAkB;CACnB;;CAEA;EACC,WAAW;EACX,kBAAkB;CACnB;;CAEA;EACC,kBAAkB;CACnB;;AAED;;AAEA,2EAA2E","sourcesContent":[".space1 {\n\tmargin-bottom: 6px !important;\n}\n\n.space2 {\n\tmargin-bottom: 12px !important;\n}\n\n.space3 {\n\tmargin-bottom: 18px !important;\n}\n\n.space4 {\n\tmargin-bottom: 24px !important;\n}\n\n.space5 {\n\tmargin-bottom: 30px !important;\n}\n\n.space6 {\n\tmargin-bottom: 36px !important;\n}\n\n.space7 {\n\tmargin-bottom: 42px !important;\n}\n\n.space8 {\n\tmargin-bottom: 48px !important;\n}\n\n.spaceTop1 {\n\tmargin-top: 6px !important;\n}\n\n.spaceTop2 {\n\tmargin-top: 12px !important;\n}\n\n.spaceTop3 {\n\tmargin-top: 18px !important;\n}\n\n.spaceTop4 {\n\tmargin-top: 24px !important;\n}\n\n.spaceTop5 {\n\tmargin-top: 30px !important;\n}\n\n.spaceTop6 {\n\tmargin-top: 36px !important;\n}\n\n.spaceTop7 {\n\tmargin-top: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-top: 48px !important;\n}\n\n.noMargin {\n\tmargin: 0px !important;\n}\n\n.padding1 {\n\tpadding-bottom: 6px !important;\n}\n\n.padding2 {\n\tpadding-bottom: 12px !important;\n}\n\n.padding3 {\n\tpadding-bottom: 18px !important;\n}\n\n.padding4 {\n\tpadding-bottom: 24px !important;\n}\n\n.padding5 {\n\tpadding-bottom: 30px !important;\n}\n\n.padding6 {\n\tpadding-bottom: 36px !important;\n}\n\n.padding7 {\n\tpadding-bottom: 42px !important;\n}\n\n.paddingTop1 {\n\tpadding-top: 6px !important;\n}\n\n.paddingTop2 {\n\tpadding-top: 12px !important;\n}\n\n.paddingTop3 {\n\tpadding-top: 18px !important;\n}\n\n.paddingTop4 {\n\tpadding-top: 24px !important;\n}\n\n.paddingTop5 {\n\tpadding-top: 30px !important;\n}\n\n.paddingTop6 {\n\tpadding-top: 36px !important;\n}\n\n.paddingTop7 {\n\tpadding-top: 42px !important;\n}\n\n.noPadding {\n\tpadding: 0px !important;\n}\n\n.spaceMarginBottom0 {\n\tmargin-bottom: 0;\n}\n\n.textBold {\n\tfont-weight: 500 !important;\n}\n\n.textBolder {\n\tfont-weight: 700 !important;\n}\n\n.textNormal {\n\tfont-weight: normal !important;\n}\n\n/*New Design Text Colors */\n\n.textDarkBlue {\n\tcolor: rgb(20, 39, 94) !important;\n}\n\n.textLightBlue {\n\tcolor: rgb(57, 87, 106) !important;\n}\n\n.textLightSandleGreen {\n\tcolor: rgb(76, 86, 41) !important;\n}\n\n.textLightBrown {\n\tcolor: rgb(115, 79, 33) !important;\n}\n\n.textMediumMaroon {\n\tcolor: rgb(87, 37, 51) !important;\n}\n\n.textBrown {\n\tcolor: rgb(160, 47, 24) !important;\n}\n\n.textMaroon {\n\tcolor: rgb(155, 49, 67) !important;\n}\n\n.textDarkBrown {\n\tcolor: rgb(83, 18, 16) !important;\n}\n\n.textMediumBrown {\n\tcolor: rgb(142, 28, 10) !important;\n}\n\n.textSkyBlue {\n\tcolor: rgb(37, 117, 141) !important;\n}\n\n.textGray {\n\tcolor: rgb(77, 65, 51) !important;\n}",".errorMessage {\n  margin-top: 5px;\n  margin-bottom: 5px;\n  display: block;\n  color: var(--alert-color);\n  font-size: 14px;\n  font-weight: normal;\n  /* margin-left: 5px; */\n}","@import '../helpers.css';\n@import '../utils.css';\n\n/** Admin - Common - Start **/\n.userText {\n\tpadding-top: 3px;\n\tcolor: var(--common-text-color);\n\tmargin: 0px;\n\tfont-size: 14px;\n}\n\n.panelHeader {\n\tborder-radius: 4px;\n\tpadding: 20px 25px;\n\tborder: 1px solid var(--primary-border);\n}\n\n.exportSection {\n\tbackground: var(--common-gray-bg-color);\n\tpadding: 24px 15px;\n\tdisplay: grid;\n\tgrid-template-columns: 28% 15% 55%;\n\talign-items: center;\n\tgrid-gap: 11px;\n\tborder: 1px solid var(--primary-border);\n\tborder-bottom: 0;\n\tborder-top-left-radius: 20px;\n\tborder-top-right-radius: 20px;\n}\n\n.exportSectionGridSub {\n\tgrid-template-columns: 50% 49% !important;\n}\n\n.exportText {\n\tcolor: var(--common-text-color) !important;\n\ttext-decoration: none !important;\n\tdisplay: inline-block;\n\tfloat: right;\n}\n\n.exportLinkImg {\n\tbackground: var(--primary-white-bg);\n\tpadding: 10px;\n\tmargin-left: 12px;\n\tborder-radius: 4px;\n}\n\n.exportImg {\n\twidth: 100%;\n\tmax-width: 16px;\n\tvertical-align: middle;\n}\n\n.linkBtn {\n\tline-height: 24px;\n\tdisplay: inline-block;\n\tvertical-align: middle;\n\tmargin-right: 15px;\n\ttext-align: center;\n}\n\n.table {\n\tdisplay: table;\n}\n\n.tableRow {\n\tdisplay: table-row;\n}\n\n.tableCell {\n\tdisplay: table-cell;\n\tfloat: none;\n}\n\n.formGroup {\n\tmargin-bottom: 6px;\n}\n\n.marginTop0 {\n\tmargin-top: 0;\n}\n\n.marginBottom20 {\n\tmargin-bottom: 20px;\n}\n\n\n/******************* Admin Banner Image Section Start ****************/\n.bannerImageBg {\n\twidth: 100%;\n\theight: 100%;\n\tmin-height: 179px;\n\tbackground-size: contain;\n\tbackground-repeat: no-repeat;\n\tbackground-position: 50% 50%;\n\tposition: relative;\n\tborder-radius: 0px;\n}\n\n.bannerDelete {\n\tposition: absolute;\n\ttop: 5px;\n\tright: 20px;\n}\n\n/*******************Admin Modal Start **********************/\na,\na:hover {\n\tcursor: pointer;\n}\n\n.exportLink {\n\tpadding-top: 10px;\n\tpadding-right: 10px;\n}\n\n.seachContent {\n\tpadding-left: 0px;\n\tmargin-bottom: 5px;\n}\n\n.marginBottom9 {\n\tmargin-bottom: 9px;\n}\n\n.spaceTop52 {\n\tmargin-top: 52px;\n}\n\n.profileViewInner {\n\tpadding: 10px;\n\tborder-top: 1px solid var(--primary-border);\n\tword-break: break-all;\n}\n\n.profileViewMain {\n\tborder: 1px solid var(--primary-border);\n\tborder-radius: 0px;\n\tborder-top: 0;\n}\n\n.profileViewlabel {\n\tdisplay: inline-block;\n\twidth: 38%;\n\tvertical-align: middle;\n}\n\n.profileViewMainContent {\n\tdisplay: inline-block;\n\twidth: 62%;\n\tvertical-align: middle;\n}\n\n.reviewsFormStar {\n\tfont-size: 32px;\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 2px;\n\tflex-wrap: wrap;\n}\n\n.reviewsFormStar svg {\n\tcursor: pointer;\n}\n\n.addLanguageText {\n\tfont-size: 16px;\n}\n\n/***************** Export Section Start *********************/\n@media screen and (max-width: 991px) {\n\t.exportSection {\n\t\tgrid-template-columns: 100%;\n\t}\n\n\t.spaceTop52 {\n\t\tmargin-top: 18px;\n\t}\n\n\t.exportText {\n\t\tfloat: none;\n\t\tmargin-top: 12px;\n\t}\n\n\t.exportSectionGridSub {\n\t\tgrid-template-columns: 100% !important;\n\t}\n}\n\n/***************** Export Section End *********************/\n/*******************Admin Modal Start **********************/\n\n/*******************Admin Modal End **********************/\n\n/*********************** Profile View Section  Start***********************/\n\n\n@media screen and (max-width: 767px) {\n\t.profileViewlabel {\n\t\twidth: 100%;\n\t\tmargin-bottom: 6px;\n\t\ttext-align: center;\n\t}\n\n\t.profileViewMainContent {\n\t\twidth: 100%;\n\t\ttext-align: center;\n\t}\n\n\t.panelHeader {\n\t\tpadding: 15px 15px;\n\t}\n\n}\n\n/*********************** Profile View Section  Start***********************/"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"space1": `admin-common-space1-EUpCb`,
	"space2": `admin-common-space2-zWH_W`,
	"space3": `admin-common-space3-VPBJ_`,
	"space4": `admin-common-space4-wjti5`,
	"space5": `admin-common-space5-EP1Pj`,
	"space6": `admin-common-space6-TR6XW`,
	"space7": `admin-common-space7-aDYEi`,
	"space8": `admin-common-space8-tH87P`,
	"spaceTop1": `admin-common-spaceTop1-yt9D5`,
	"spaceTop2": `admin-common-spaceTop2-XVhPG`,
	"spaceTop3": `admin-common-spaceTop3-bOf9o`,
	"spaceTop4": `admin-common-spaceTop4-G2Y_3`,
	"spaceTop5": `admin-common-spaceTop5-uxjKO`,
	"spaceTop6": `admin-common-spaceTop6-WXTbd`,
	"spaceTop7": `admin-common-spaceTop7-IOcZY`,
	"spaceTop8": `admin-common-spaceTop8-lpaUv`,
	"noMargin": `admin-common-noMargin-xiyaX`,
	"padding1": `admin-common-padding1-fkpFl`,
	"padding2": `admin-common-padding2-utxnM`,
	"padding3": `admin-common-padding3-jl9Oh`,
	"padding4": `admin-common-padding4-coj31`,
	"padding5": `admin-common-padding5-QS7wE`,
	"padding6": `admin-common-padding6-TnaWJ`,
	"padding7": `admin-common-padding7-XUGQV`,
	"paddingTop1": `admin-common-paddingTop1-n0hRz`,
	"paddingTop2": `admin-common-paddingTop2-DW4ND`,
	"paddingTop3": `admin-common-paddingTop3-LmzY3`,
	"paddingTop4": `admin-common-paddingTop4-D_wRe`,
	"paddingTop5": `admin-common-paddingTop5-H_v9a`,
	"paddingTop6": `admin-common-paddingTop6-zgg9B`,
	"paddingTop7": `admin-common-paddingTop7-yssBl`,
	"noPadding": `admin-common-noPadding-Yj5SJ`,
	"spaceMarginBottom0": `admin-common-spaceMarginBottom0-ESBiv`,
	"textBold": `admin-common-textBold-FXcH4`,
	"textBolder": `admin-common-textBolder-nzptV`,
	"textNormal": `admin-common-textNormal-XHEB8`,
	"textDarkBlue": `admin-common-textDarkBlue-JnHam`,
	"textLightBlue": `admin-common-textLightBlue-rKfzR`,
	"textLightSandleGreen": `admin-common-textLightSandleGreen-SzcnA`,
	"textLightBrown": `admin-common-textLightBrown-c50qS`,
	"textMediumMaroon": `admin-common-textMediumMaroon-Nkitm`,
	"textBrown": `admin-common-textBrown-VzOa0`,
	"textMaroon": `admin-common-textMaroon-ahu0K`,
	"textDarkBrown": `admin-common-textDarkBrown-UsXO5`,
	"textMediumBrown": `admin-common-textMediumBrown-hHkvR`,
	"textSkyBlue": `admin-common-textSkyBlue-SQvqO`,
	"textGray": `admin-common-textGray-Lcc8k`,
	"errorMessage": `admin-common-errorMessage-j5Ygy`,
	"userText": `admin-common-userText-rsGMR`,
	"panelHeader": `admin-common-panelHeader-chzWo`,
	"exportSection": `admin-common-exportSection-vVJQP`,
	"exportSectionGridSub": `admin-common-exportSectionGridSub-lBU2P`,
	"exportText": `admin-common-exportText-Qyk3F`,
	"exportLinkImg": `admin-common-exportLinkImg-G1EAi`,
	"exportImg": `admin-common-exportImg-ZxYbH`,
	"linkBtn": `admin-common-linkBtn-IGCPQ`,
	"table": `admin-common-table-aD00b`,
	"tableRow": `admin-common-tableRow-Qhsi0`,
	"tableCell": `admin-common-tableCell-_9nUx`,
	"formGroup": `admin-common-formGroup-zT4cQ`,
	"marginTop0": `admin-common-marginTop0-K13Ia`,
	"marginBottom20": `admin-common-marginBottom20-_G4yi`,
	"bannerImageBg": `admin-common-bannerImageBg-kGZc6`,
	"bannerDelete": `admin-common-bannerDelete-PiySL`,
	"exportLink": `admin-common-exportLink-WGQAF`,
	"seachContent": `admin-common-seachContent-ZYA_w`,
	"marginBottom9": `admin-common-marginBottom9-XKvSQ`,
	"spaceTop52": `admin-common-spaceTop52-mcs6I`,
	"profileViewInner": `admin-common-profileViewInner-sS3aA`,
	"profileViewMain": `admin-common-profileViewMain-TBRXl`,
	"profileViewlabel": `admin-common-profileViewlabel-z7FPz`,
	"profileViewMainContent": `admin-common-profileViewMainContent-OW6Eo`,
	"reviewsFormStar": `admin-common-reviewsFormStar-H9ymj`,
	"addLanguageText": `admin-common-addLanguageText-SJQ74`
};
module.exports = ___CSS_LOADER_EXPORT___;
